import { render, staticRenderFns } from "./completedpayments.vue?vue&type=template&id=333aecce"
import script from "./completedpayments.vue?vue&type=script&lang=js"
export * from "./completedpayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports